<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import RequestItemTaskPanel from "@shared/svelte/Components/RequestableItems/RequestItemTaskPanel.svelte";
  import RequestItemTooltip from "@shared/svelte/Components/RequestableItems/RequestItemTooltip.svelte";

  import { EventTracking } from "@shared/services/event_tracking/events";
  import { pluralize } from "@shared/svelte/Modules/pluralize";

  import { RequestItemEntity } from "@shared/services/event_tracking/entities";

  const { trackClick } = EventTracking;

  export let cartWidgetItem: any;
  export let fulfillmentWarehouseId: number | null = null;
  export let isCartPage: boolean = false;

  let open: boolean = false;

  const requestable =
    cartWidgetItem.quantity_restrictions?.additional_action ===
    "quantity_restrictions.request_item";

  let itemsInCart;
  let hasItemsInCart: boolean = false;
  let distributor;
  let product;
  let targetObject;
  let trackingParams: RequestItemEntity[];
  $: {
    itemsInCart = cartWidgetItem.buying_options
      .map(option => {
        const quantity = option.quantity;
        if (quantity > 0) {
          return `${quantity} ${pluralize(option.label.toLowerCase(), quantity)}`;
        }
      })
      .filter(Boolean)
      .join(", ");

    hasItemsInCart = itemsInCart.length > 0;
    distributor = cartWidgetItem.distributor_summary;
    product = cartWidgetItem.product_summary;
    targetObject = hasItemsInCart
      ? "request_task_panel_open_edit_button"
      : "request_task_panel_open_request_button";
    trackingParams = [
      new RequestItemEntity({ distributor_id: distributor?.id, product_id: product?.id }),
    ];
  }
</script>

<style>
  .badge {
    background: #eaeaea;
    padding: 2px 8px;
  }

  .cart-page-button {
    margin-bottom: 10px;
  }
</style>

{#if requestable}
  <div class="craft">
    <RequestItemTooltip bind:distributor bind:product />
    <div class:fizz-flex-row-0={isCartPage}>
      {#if hasItemsInCart}
        <div
          class="fizz-flex-row fizz-bordered fizz-justify-center fizz-stack-8 badge"
          class:fizz-max-content={isCartPage}
        >
          Requesting {itemsInCart}
        </div>
      {/if}
      {#if isCartPage}
        <button
          class="fizz-icon-button-small cart-page-button"
          data-testid="request-task-panel-button"
          on:click={() => {
            trackClick("request_task_panel_open_pencil_button", trackingParams);
            open = true;
          }}
        >
          <Icon type="Pencil" height="14" width="14" />
        </button>
      {:else}
        <button
          class="fizz-button fizz-full-width"
          on:click={() => {
            trackClick(targetObject, trackingParams);
            open = true;
          }}
        >
          {hasItemsInCart ? "Edit Request" : "Request Item"}
        </button>
      {/if}
    </div>
    <RequestItemTaskPanel bind:open {cartWidgetItem} {fulfillmentWarehouseId} {isCartPage} />
  </div>
{:else}
  <slot name="cart-widget" />
{/if}
